import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
    destinationText: PropTypes.string.isRequired,
    showEdit: PropTypes.bool,
    editURL: PropTypes.string
};

function VerifyDestination(props) {
    return (
        <div className="mfa-info-edit">
            <span className="mfa-info-edit-text">{props.destinationText}</span>
            {props.showEdit && (
                <a href={props.editURL} className=" mfa-info-edit-action">
                    Edit
                </a>
            )}
        </div>
    );
}

VerifyDestination.propTypes = propTypes;
export default VerifyDestination;
